import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { ChevronRight, FlightLand, FlightTakeoffOutlined } from '@mui/icons-material';
import { formatDate, getDateFromSap } from '@core/utils';

interface IDetalhesPeriodoCardProps {
    path: any;
    inicioPeriodo: string;
    dataInicio: string;
    diasProgramados: number;
    diasAbono: number;
    adiantamento13: string;
    descricaoStatus: string;
}

const gridStyles = {
    marginTop: '0.5rem',
    cursor: 'pointer',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    backgroundColor: '#fff',
    display: 'flex',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    width: '100%',
    borderRadius: '8px',
    padding: '1rem'
};

const textStyleTitle = {
    fontSize: '0.8rem',
    lineHeight: 1,
    fontWeight: 'bold',
    marginTop: '1rem'
};

const textStyleDescription = {
    fontSize: '0.8rem',
    lineHeight: 1,
    marginTop: '0.5rem',
    color: 'rgba(0, 0, 0, 0.87)'
};

const flagStyle = {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'uppercase',
    margin: 0,
    color: '#fff',
    fontWeight: '600',
    background: '#FF00FF',
    padding: '2px 5px',
    borderRadius: '5px',
    gap: '5px'
};

const buildDetalhesFeriasUrl = (path: string, inicioPeriodo: string, inicioFerias: string, diasProgramados: number, diasAbono: number, adiantamento13: string, descricaoStatus: string) => {
    return path
        .replace(':inicioPeriodo', inicioPeriodo)
        .replace(':inicioFerias', inicioFerias)
        .replace(':diasProgramados', diasProgramados.toString())
        .replace(':diasAbono', diasAbono.toString())
        .replace(':adiantamento13', adiantamento13)
        .replace(':descricaoStatus', descricaoStatus);
};

export const DetalhesPeriodoCard: React.FC<IDetalhesPeriodoCardProps> = ({ path, inicioPeriodo, dataInicio, diasProgramados, diasAbono, adiantamento13, descricaoStatus }) => {
    const navigate = useNavigate();

    return (
        <Grid item xs={12} onClick={() => navigate(buildDetalhesFeriasUrl(path, inicioPeriodo, dataInicio, diasProgramados, diasAbono, adiantamento13, descricaoStatus))} sx={{ ...gridStyles }}>
            <Grid container justifyContent="space-between">
                <Grid item xs={12}>
                    <Typography component="span" sx={{ ...textStyleDescription, ...flagStyle }}>
                        {descricaoStatus === 'Quitado' ? <FlightLand /> : <FlightTakeoffOutlined />}
                        {descricaoStatus}
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography sx={{ ...textStyleTitle }}>Dias de férias</Typography>
                    <Typography sx={{ ...textStyleDescription }}>{diasProgramados}</Typography>

                    <Typography sx={{ ...textStyleTitle }}>Adto. 13º salário</Typography>
                    <Typography sx={{ ...textStyleDescription }}>{adiantamento13}</Typography>
                </Grid>
                <Grid item sx={{ pr: '0.5rem' }}>
                    <Typography sx={{ ...textStyleTitle }}>Data de início</Typography>
                    <Typography sx={{ ...textStyleDescription }}>{formatDate(getDateFromSap(dataInicio), false)}</Typography>

                    <Typography sx={{ ...textStyleTitle }}>Dias de abono</Typography>
                    <Typography sx={{ ...textStyleDescription }}>{diasAbono}</Typography>
                </Grid>
            </Grid>
            <ChevronRight />
        </Grid>
    );
};
